import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideNgxStripe } from 'ngx-stripe';
import { ToastrModule } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { AuthenticationInterceptor } from './authentication.interceptor';
import { CompletionStore } from './stores/completion-store';
import { AttributionService } from './services/attribution.service';
import { AuthenticationService } from './services/authentication.service';
import { DataRefreshService } from './services/data-refresh.service';
import { environment } from '../environments/environment';
import { routes } from './app-routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
    ),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    provideNgxStripe(environment.stripeKey),
    importProvidersFrom(ToastrModule.forRoot({ timeOut: 2000 })),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      multi: true,
    },
    DatePipe,
    CompletionStore,
    provideAppInitializer(async () => {
      const authService = inject(AuthenticationService);
      const dataRefreshService = inject(DataRefreshService);
      inject(AttributionService).capture(window.location.search);
      authService.purgeLegacyLocalStorage();
      if (authService.isUserLoggedIn()) {
        try {
          await dataRefreshService.refreshAll();
        } catch (err) {
          // Genuine auth failures (401) are already handled globally by
          // AuthenticationInterceptor, which force-logs-out correctly. Don't
          // duplicate that here — this catch previously force-logged-out on
          // *any* failure, including a plain transient network/server error,
          // which silently signed users out of perfectly valid sessions.
          console.error('Initial data refresh failed:', err);
        }
      }
    }),
  ],
};
